import { createContext, useContext, useMemo, useState } from 'react';
import useConversionActions from '../hooks/APIHooks/appointments/useConversionActions';
import { Conversion } from '../types/conversion';

// datatype of the context declared here
interface IConversionContext {
  conversionList: Array<Conversion>;
  targetedConversion: Conversion | null;
  searchText: string;
  showDeleteModal: boolean;
  showEditModal: boolean;
  setTargetedConversion: React.Dispatch<
    React.SetStateAction<Conversion | null>
  >;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

// creating the context here
const ConversionContext = createContext<IConversionContext | null>(null);

const ConversionProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [targetedConversion, setTargetedConversion] =
    useState<Conversion | null>(null);

  const [searchText, setSearchText] = useState<string>('');

  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  // integration of API hooks here
  const { getMinuteConversionListHandler } =
    useConversionActions('conversionList');

  console.log('CONVERSION LIST: ', getMinuteConversionListHandler.data?.data);

  // setting conversion list into local state here

  const conversionList = useMemo(() => {
    if (!getMinuteConversionListHandler.data?.is_success) return [];

    return getMinuteConversionListHandler.data.data.filter((conversion) =>
      searchText
        ? conversion.name.toLowerCase().includes(searchText.toLowerCase())
        : conversion
    );
  }, [getMinuteConversionListHandler.data, searchText]);

  // rendering the context provider here
  return (
    <ConversionContext.Provider
      value={{
        conversionList,
        targetedConversion,
        searchText,
        showDeleteModal,
        showEditModal,
        setTargetedConversion,
        setSearchText,
        setShowDeleteModal,
        setShowEditModal,
        isError: getMinuteConversionListHandler.isError,
        isLoading: getMinuteConversionListHandler.isLoading,
        isSuccess: getMinuteConversionListHandler.isSuccess,
      }}
    >
      {children}
    </ConversionContext.Provider>
  );
};

export default ConversionProvider;

// custom hook to access the context declared here
export const useConversionContext = () => {
  const context = useContext(ConversionContext);

  if (!context) {
    throw new Error('useConversionContext must be within ConversionProvider!');
  }

  return context;
};
